

















import { Component, Prop, Vue } from "vue-property-decorator";
import CzIcon from "./CzIcon.vue";

@Component({ components: { CzIcon } })
export default class CzDone extends Vue {
  @Prop({ type: Boolean, default: false }) done!: boolean;
  @Prop({ type: Boolean, default: false }) toggle!: boolean;
  @Prop({ type: String, default: "" }) label!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
}
